module.exports = __webpack_public_path__ + "static/media/pbb_banner2.f2ee30fe.svg";